/**
 * @generated SignedSource<<2ada5483db1fcd3054cc9e78725bd988>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type favoritePage_Query$variables = {
  matchId: string;
};
export type favoritePage_Query$data = {
  readonly node: {
    readonly baseCase?: {
      readonly " $fragmentSpreads": FragmentRefs<"contactModule_baseCase">;
    } | null | undefined;
    readonly offmarketCase?: {
      readonly " $fragmentSpreads": FragmentRefs<"contactModuleOffmarket_offmarketCase">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"favoritePageHero_fragment">;
  } | null | undefined;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"myPageSpotsEntity">;
  } | null | undefined;
};
export type favoritePage_Query = {
  response: favoritePage_Query$data;
  variables: favoritePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "matchId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "matchId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearBuilt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Employee",
    "kind": "LinkedField",
    "name": "employee",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employeePrimaryImageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Shop",
        "kind": "LinkedField",
        "name": "offerShop",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v8/*: any*/),
          (v6/*: any*/),
          (v5/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDataConnection",
  "kind": "LinkedField",
  "name": "mediaDataConnection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaDataEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Media",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "resourceType",
                  "value": "Asset"
                }
              ],
              "kind": "ScalarField",
              "name": "resourceUrl",
              "storageKey": "resourceUrl(resourceType:\"Asset\")"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaType",
              "kind": "LinkedField",
              "name": "mediaType",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caseDescription",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caseDescriptionHeading",
  "storageKey": null
},
v15 = [
  (v12/*: any*/)
],
v16 = {
  "alias": "businessPropertyType",
  "args": null,
  "kind": "ScalarField",
  "name": "propertyType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "favoritePage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "favoritePageHero_fragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "baseCase",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "contactModule_baseCase"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OffmarketCase",
                "kind": "LinkedField",
                "name": "offmarketCase",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "contactModuleOffmarket_offmarketCase"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "CasePotentialBuyer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "myPageSpotsEntity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "favoritePage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "baseCase",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isBaseCase"
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CaseAnnounced",
                    "kind": "LinkedField",
                    "name": "caseAnnounced",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zipCode",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "energyMark",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "heat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BaseCaseMainOffer",
                    "kind": "LinkedField",
                    "name": "baseCaseMainOffer",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cashPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TotalCosts",
                        "kind": "LinkedField",
                        "name": "totalCosts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yearlyGrossOutput",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yearlyNetOutput",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minimumPayout",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "technicalPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IncreasePerYear",
                        "kind": "LinkedField",
                        "name": "rateOfReturn",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "annualAmount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeOffer",
                        "kind": "LinkedField",
                        "name": "employeeOffer",
                        "plural": true,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CaseAreas",
                    "kind": "LinkedField",
                    "name": "caseAreas",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "livableArea",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "plotAreaSum",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "atticArea",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "basementArea",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "builtUpArea",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commercialArea",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherBuildingsSum",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "annualHeatingPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "floorCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roomCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "buildings",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuildingInclArea",
                        "kind": "LinkedField",
                        "name": "buildingInclAreas",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "area",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "amount",
                        "value": 2
                      }
                    ],
                    "concreteType": "OpenHouse",
                    "kind": "LinkedField",
                    "name": "openHouse",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityType",
                        "kind": "LinkedField",
                        "name": "activityType",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRegistration",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nameOnTimeline",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRegistred",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "registrationDeadline",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": "openHouse(amount:2)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noAdvertisement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gpsCoordinates",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ownerCostsTotalMonthly",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": "salesStatus",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "type": "SalesCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v15/*: any*/),
                    "type": "RectifyCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v15/*: any*/),
                    "type": "CounselingPropertyCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": "rentalStatus",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rentMonthly",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountWater",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountHeat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountElectricity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prepaidRent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deposit",
                        "storageKey": null
                      }
                    ],
                    "type": "RentalCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v15/*: any*/),
                    "type": "CounselingCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "businessSalesCaseStatus",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "buildings",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMainBuilding",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "investmentProperty",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tenanciesYearlyRentTotal",
                        "storageKey": null
                      }
                    ],
                    "type": "BusinessSalesCase",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": "businessRentalCase",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      }
                    ],
                    "type": "BusinessRentalCase",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OffmarketCase",
                "kind": "LinkedField",
                "name": "offmarketCase",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "businessPropertyType",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "caseId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeOffer",
                    "kind": "LinkedField",
                    "name": "mainOfferEmployees",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "CasePotentialBuyer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPageSpot",
            "kind": "LinkedField",
            "name": "spots",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "myPageSpotRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPageSpotEntry",
                "kind": "LinkedField",
                "name": "entries",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7698d4fc6a3a335e5f55eefa7bd5f55",
    "id": null,
    "metadata": {},
    "name": "favoritePage_Query",
    "operationKind": "query",
    "text": "query favoritePage_Query(\n  $matchId: ID!\n) {\n  node(id: $matchId) {\n    __typename\n    ... on CasePotentialBuyer {\n      ...favoritePageHero_fragment\n      baseCase {\n        __typename\n        ...contactModule_baseCase\n        id\n      }\n      offmarketCase {\n        ...contactModuleOffmarket_offmarketCase\n        id\n      }\n    }\n    id\n  }\n  viewer {\n    ...myPageSpotsEntity\n    id\n  }\n}\n\nfragment caseFullscreenGallery_mediaDataConnection on MediaDataConnection {\n  ...caseImagesSwiper_mediaDataConnection\n}\n\nfragment caseGallerySwiper_mediaDataConnection on MediaDataConnection {\n  edges {\n    node {\n      id\n      resourceUrl(resourceType: Asset)\n      mediaType {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment caseGallery_mediaDataConnection on MediaDataConnection {\n  ...caseGallerySwiper_mediaDataConnection\n}\n\nfragment caseImagesSwiper_mediaDataConnection on MediaDataConnection {\n  edges {\n    node {\n      id\n      resourceUrl(resourceType: Asset)\n      mediaType {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment caseImages_Media on MediaDataConnection {\n  ...caseGallery_mediaDataConnection\n  ...caseFullscreenGallery_mediaDataConnection\n  ...caseImagesSwiper_mediaDataConnection\n  edges {\n    node {\n      resourceUrl(resourceType: Asset)\n      mediaType {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment contactCard_employee on Employee {\n  lastName\n  firstName\n  fullName\n  phone\n  employeePrimaryImageUrl\n  title\n  offerShop {\n    name\n    phone\n    city\n    address\n    id\n  }\n}\n\nfragment contactModuleOffmarket_offmarketCase on OffmarketCase {\n  id\n  caseId\n  caseDescriptionHeading\n  propertyType\n  businessPropertyType\n  mainOfferEmployees {\n    employee {\n      id\n      fullName\n      ...contactCard_employee\n    }\n  }\n}\n\nfragment contactModule_baseCase on BaseCase {\n  __isBaseCase: __typename\n  id\n  address\n  baseCaseMainOffer {\n    employeeOffer {\n      employee {\n        id\n        fullName\n        ...contactCard_employee\n        offerShop {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment favoritePageHero_fragment on CasePotentialBuyer {\n  __typename\n  baseCase {\n    __typename\n    ...matchHeroContentFragment_baseCase\n    ...registerOpenHouseModalFragment\n    ...openHouseImageOverlay_baseCase\n    noAdvertisement\n    gpsCoordinates\n    openHouse(amount: 2) {\n      __typename\n      id\n    }\n    mediaDataConnection {\n      ...caseImages_Media\n    }\n    id\n  }\n  offmarketCase {\n    ...matchHeroContentFragment_offmarketCase\n    mediaDataConnection {\n      ...caseImages_Media\n    }\n    id\n  }\n}\n\nfragment matchHeroContentAgriculturalCase_baseCase on BaseCase {\n  __isBaseCase: __typename\n  energyMark\n  yearBuilt\n  heat\n  baseCaseMainOffer {\n    cashPrice\n    totalCosts {\n      yearlyGrossOutput\n      yearlyNetOutput\n      minimumPayout\n    }\n  }\n  caseAreas {\n    livableArea\n    plotAreaSum\n  }\n  ... on SalesCase {\n    ownerCostsTotalMonthly\n    propertyType\n    salesStatus: status\n  }\n  ... on RectifyCase {\n    propertyType\n  }\n  ... on CounselingPropertyCase {\n    propertyType\n  }\n  ... on RentalCase {\n    propertyType\n    rentalStatus: status\n  }\n  ... on CounselingCase {\n    propertyType\n  }\n  ... on BusinessSalesCase {\n    businessSalesCaseStatus: status\n    businessPropertyType: propertyType\n  }\n  ... on BusinessRentalCase {\n    businessPropertyType: propertyType\n    businessRentalCase: status\n  }\n}\n\nfragment matchHeroContentBusinessSalesCase on BaseCase {\n  __isBaseCase: __typename\n  energyMark\n  yearBuilt\n  baseCaseMainOffer {\n    cashPrice\n    rateOfReturn {\n      annualAmount\n    }\n  }\n  caseAreas {\n    commercialArea\n    livableArea\n    plotAreaSum\n    builtUpArea\n  }\n  ... on BusinessSalesCase {\n    buildings {\n      __typename\n      isMainBuilding\n      yearBuilt\n    }\n    investmentProperty\n    businessPropertyType: propertyType\n    status\n    tenanciesYearlyRentTotal\n  }\n}\n\nfragment matchHeroContentCounselingCase on BaseCaseMainOffer {\n  cashPrice\n}\n\nfragment matchHeroContentFragment_baseCase on BaseCase {\n  __isBaseCase: __typename\n  id\n  caseAnnounced {\n    linkUrl\n    type\n  }\n  ...matchHeroDetailsFragment\n  ... on SalesCase {\n    noAdvertisement\n    caseDescription\n    caseDescriptionHeading\n    __typename\n  }\n}\n\nfragment matchHeroContentFragment_offmarketCase on OffmarketCase {\n  caseDescription\n  caseDescriptionHeading\n  ...matchHeroOffmarketDetailsFragment_offmarketCase\n}\n\nfragment matchHeroContentRentalCase on BaseCase {\n  __isBaseCase: __typename\n  energyMark\n  yearBuilt\n  roomCount\n  caseAreas {\n    livableArea\n  }\n  ... on RentalCase {\n    rentMonthly\n    accountWater\n    accountHeat\n    accountElectricity\n    prepaidRent\n    deposit\n  }\n}\n\nfragment matchHeroContentSalesCase on BaseCase {\n  __isBaseCase: __typename\n  energyMark\n  yearBuilt\n  heat\n  otherBuildingsSum\n  annualHeatingPrice\n  floorCount\n  roomCount\n  buildings {\n    __typename\n    buildingInclAreas {\n      area\n    }\n  }\n  baseCaseMainOffer {\n    cashPrice\n    technicalPrice\n    totalCosts {\n      yearlyGrossOutput\n      yearlyNetOutput\n      minimumPayout\n    }\n  }\n  caseAreas {\n    livableArea\n    plotAreaSum\n    atticArea\n    basementArea\n    builtUpArea\n  }\n  ... on SalesCase {\n    ownerCostsTotalMonthly\n    propertyType\n    salesStatus: status\n  }\n}\n\nfragment matchHeroDetailsFragment on BaseCase {\n  __isBaseCase: __typename\n  address\n  zipCode\n  city\n  ...matchHeroContentAgriculturalCase_baseCase\n  ...matchHeroContentSalesCase\n  ...matchHeroContentRentalCase\n  ...matchHeroContentBusinessSalesCase\n  baseCaseMainOffer {\n    ...matchHeroContentCounselingCase\n  }\n  ... on SalesCase {\n    propertyType\n    __typename\n  }\n  ... on RectifyCase {\n    __typename\n    propertyType\n  }\n  ... on CounselingPropertyCase {\n    __typename\n    propertyType\n  }\n  ... on RentalCase {\n    __typename\n    propertyType\n  }\n  ... on CounselingCase {\n    __typename\n    propertyType\n  }\n  ... on BusinessSalesCase {\n    __typename\n    businessPropertyType: propertyType\n  }\n  ... on BusinessRentalCase {\n    __typename\n    businessPropertyType: propertyType\n  }\n}\n\nfragment matchHeroOffmarketDetailsFragment_offmarketCase on OffmarketCase {\n  propertyType\n  businessPropertyType\n}\n\nfragment myPageSpotsEntity on Viewer {\n  spots {\n    myPageSpotRole\n    entries {\n      id\n      linkUrl\n      imageUrl\n      width\n    }\n    id\n  }\n}\n\nfragment openHouseImageOverlay_baseCase on BaseCase {\n  __isBaseCase: __typename\n  openHouse(amount: 2) {\n    registrationDeadline\n    activityType {\n      nameOnTimeline\n      isRegistration\n      id\n    }\n    startDate\n    isRegistred\n    id\n  }\n}\n\nfragment registerOpenHouseModalFragment on BaseCase {\n  __isBaseCase: __typename\n  openHouse(amount: 2) {\n    activityType {\n      isRegistration\n      nameOnTimeline\n      id\n    }\n    isRegistred\n    id\n    startDate\n    endDate\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "ea2d10e0db1d81a86340c0b7261ca716";

export default node;
